<template>
    <div id="room-wrapper">
         <div class="groups" v-if="roomData">
            <div class="group" v-bind:key="key" v-for="(group, key) in roomData.groups">
                <div class="box">
                    <h2 class="title">Grupp: {{key}}</h2>
                    <table class="table is-striped is-bordered is-fullwidth">
                        <thead>
                        <tr>
                            <th>Media</th>
                            <th>Åldersgrupp</th>
                            <th>Verktyg</th>
                        </tr>
                        </thead>
                        <tbody>
                            <room-image v-for="(string,key) in group" v-bind:key="key" :orgdata="string" :index="key" :keyname="string.key || 'none'" :group="group" @stringDeleted="deleteMedia(...arguments)"></room-image>
                            <room-image :is_new="true" :group="key"></room-image>
                        </tbody>

                    </table>
                </div>
            </div>
            <room-help :orgdata="helpData"></room-help>
            <!--
            <h3 class="title is-3">New row</h3>
            <room-image :is_new="true"></room-image>
            -->
        </div>
    </div>
</template>

<script>
import RoomData from '@/mixins/RoomMixin'
import RoomImage from '../partials/RoomImage'
export default {
  name: 'GenericRoomImage',
  components: { RoomImage },
  mixins: [RoomData],
  data () {
    return {
      data: {
        title: 'Test'

      }
    }
  },
  computed: {

  },
  methods: {
    addRow: function (group) {

    }
  }
}
</script>
